import useViewportName from '@apps/www/src/www/hooks/useViewportName';
import SVNewBadge from '@pkgs/shared-client/components/SVNewBadge';
import cn from '@pkgs/shared-client/helpers/cn';
import useFromMobileApp from '@pkgs/shared-client/hooks/useFromMobileApp';
import minimatch from 'minimatch';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import SVLink from './SVLink';

type Item = {
	to: string;
	label: string;
	matchPrefix?: boolean;
	new?: boolean;
	onClick?: (event: React.UIEvent) => void;
	subItems?: Item[];
	showSubItems?: boolean;
};

type Props = {
	items: Item[];
};

const SVPageNav = ({ items }: Props) => {
	const router = useRouter();
	const viewportName = useViewportName();
	const isFromMobileApp = useFromMobileApp();

	useEffect(() => {
		const selectedElement = document.querySelector('.selected-item');
		if (selectedElement && viewportName === 'small') {
			selectedElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
		}
	}, [viewportName]);

	if (isFromMobileApp) {
		return null;
	}

	return (
		<ul className="-sm:flex-row -sm:overflow-x-auto -sm:pb-4 -sm:overflow-y-hidden -sm:space-x-[10px] -sm:space-y-0 flex flex-col space-y-3 text-left">
			{items.map((item, i) => (
				<React.Fragment key={i}>
					<li key={i}>
						<SVLink
							to={item.to}
							onClick={item.onClick}
							className={cn(
								cn(
									'type-pagenav -sm:rounded-full -sm:w-max -sm:border-gray-700 -sm:p-4 -sm:border-2 duration-over inline-flex items-center font-medium leading-none text-gray-400 transition-colors ease-out hover:text-gray-200',
									(minimatch(
										router.asPath,
										`${item.to}${item.matchPrefix ? '{*,}' : ''}`,
									) ||
										(item.subItems &&
											item.subItems.some((subItem) =>
												minimatch(
													router.asPath,
													`${subItem.to}${
														subItem.matchPrefix ? '{*,}' : ''
													}`,
												),
											))) &&
										' -sm:border-primary selected-item text-primary',
								),
							)}
						>
							{item.label}
							{item.new ? <SVNewBadge className="-sm:hidden" /> : null}
						</SVLink>
					</li>
					{(minimatch(router.asPath, `${item.to}${item.matchPrefix ? '{*,}' : ''}`) ||
						(item.subItems &&
							item.subItems.some((subItem) =>
								minimatch(
									router.asPath,
									`${subItem.to}${subItem.matchPrefix ? '{*,}' : ''}`,
								),
							))) &&
						item.subItems &&
						item.showSubItems &&
						item.subItems.map((subItem, j) => (
							<li key={j}>
								<SVLink
									to={subItem.to}
									className={cn(
										cn(
											'type-pagenav -sm:hidden block px-6 font-medium leading-none text-gray-400 transition-colors ease-out hover:text-gray-200',
											minimatch(
												router.asPath,
												`${subItem.to}${subItem.matchPrefix ? '{*,}' : ''}`,
											) && ' text-primary',
										),
									)}
								>
									{subItem.label}
								</SVLink>
							</li>
						))}
				</React.Fragment>
			))}
		</ul>
	);
};

export default SVPageNav;
